// App Auth Actions
import ACTIONS from "@/Constants/actionsList";

// Helpers
import { supportedSystemPositions } from "@/Common/helpers/Positions";

const POSITIONS = supportedSystemPositions();

// API's
//Service Departmental
import {
	//Queries
	getServiceDepartmentalPayPlans,
	getServiceDepartmentalPayPlan,
	getServiceDepartmentalPayPlanMatches,
	getServiceDepartmentalPayPlansSidebarTree,
	//Mutations
	createServiceDepartmentalPayPlan,
	saveNewServiceDepartmentalPayPlan,
	cloneServiceDepartmentalPayPlan,
	updateServiceDepartmentalPayPlan,
	updateServiceDepartmentalAvailablePayPlan,
	deleteServiceDepartmentalPayPlan,
	//Subscriptions
	onCreateServiceDepartmentalPayPlan,
	onCloneServiceDepartmentalPayPlan,
	onUpdateServiceDepartmentalPayPlan,
	onDeleteServiceDepartmentalPayPlan,
	onUpdateServiceDepartmentalAvailablePayPlan,
} from "@/PayPlans/api/managers/departmental";

const EDIT_ACTIONS = new Map([
	[POSITIONS.SERVICE.SERVICE_MANAGER, ACTIONS.EDIT_SERVICE_MANAGER_PAY_PLANS],
	[POSITIONS.SERVICE.SERVICE_DIRECTOR, ACTIONS.EDIT_SERVICE_DIRECTOR_PAY_PLANS],
	[POSITIONS.SERVICE.SERVICE_FOREMAN, ACTIONS.EDIT_SERVICE_FOREMAN_PAY_PLANS],
	[POSITIONS.PARTS.PARTS_MANAGER, ACTIONS.EDIT_PARTS_MANAGER_PAY_PLANS],
	[POSITIONS.PARTS.PARTS_DIRECTOR, ACTIONS.EDIT_PARTS_DIRECTOR_PAY_PLANS],
	[POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE, ACTIONS.EDIT_PARTS_COUNTER_ASSOCIATE_PAY_PLANS],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER, ACTIONS.EDIT_BODY_SHOP_PRODUCT_MANAGER_PAY_PLANS],
	[POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER, ACTIONS.EDIT_BODY_SHOP_MANAGER_PAY_PLANS],
	[POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN, ACTIONS.EDIT_BODY_SHOP_FOREMAN_PAY_PLANS],
]);

const getDepartmentalEditActions = (position: string) => {
	return {
		editable: EDIT_ACTIONS.get(position) ?? "",
	};
};

const getServiceDepartmentalServices = (position: string) => {
	// Auth actions
	const actions = getDepartmentalEditActions(position);

	// API Queries
	const getPayPlan = async (locationId: string, id: string, extraPosition: string) =>
		getServiceDepartmentalPayPlan(locationId, id, extraPosition || position);
	const getMatches = async (locationId: string, id: string, extraPosition: string) =>
		getServiceDepartmentalPayPlanMatches(locationId, id, extraPosition || position);

	const queries = {
		getPayPlan,
		getMatches,
		getPayPlans: getServiceDepartmentalPayPlans,
		getPayPlansSidebarTree: getServiceDepartmentalPayPlansSidebarTree,
	};

	// API Mutations
	const mutations = {
		addPayPlan: createServiceDepartmentalPayPlan,
		saveNewPayPlan: saveNewServiceDepartmentalPayPlan,
		updatePayPlan: updateServiceDepartmentalPayPlan,
		deletePayPlan: deleteServiceDepartmentalPayPlan,
		clonePayPlan: cloneServiceDepartmentalPayPlan,
		updateAvailablePayPlan: updateServiceDepartmentalAvailablePayPlan,
	};

	const subscriptions = new Map([
		["onClonePayPlan", { query: onCloneServiceDepartmentalPayPlan, getter: "onCloneServiceDepartmentalPayPlan" }],
		["onCreatePayPlan", { query: onCreateServiceDepartmentalPayPlan, getter: "onCreateServiceDepartmentalPayPlan" }],
		["onDeletePayPlan", { query: onDeleteServiceDepartmentalPayPlan, getter: "onDeleteServiceDepartmentalPayPlan" }],
		["onUpdatePayPlan", { query: onUpdateServiceDepartmentalPayPlan, getter: "onUpdateServiceDepartmentalPayPlan" }],
		["onUpdateAnyPayPlan", { query: "", getter: "" }],
		[
			"onUpdateAvailablePayPlan",
			{ query: onUpdateServiceDepartmentalAvailablePayPlan, getter: "onUpdateServiceDepartmentalAvailablePayPlan" },
		],
	]);

	return {
		actions,
		queries,
		mutations,
		subscriptions,
	};
};

export { getServiceDepartmentalServices };
